<script lang="ts">
  export let isPrefix: boolean;
  export let text: string;
</script>

<small class="pl_input__note {isPrefix ? ' pl_input__prefix' : ' pl_input__suffix'}">{text}</small>
